import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ReusableModal from "../../../components/atoms/modal/ReusableModal";
import { postCustomerRequestData } from "../CustomerRequest/CustomerRequestApi";

const HistoricalData = ({ show, onHide, onSubmit }) => {
  const [message, setMessage] = useState("");

  const userData = JSON.parse(localStorage.getItem("userData")) || {};
  const companyId = userData.companyId || 0;
  const locationId = userData.locationID || 0;
  const requestedBy = userData.userID || 0;

  const handleSubmit = async () => {
    const payload = {
      requestedBy,
      companyId,
      locationId,
      isTechnicalIssue: false,
      isQuestionAboutSample: false,
      isEnvelopeRequest: false,
      isHistoricalData: true,
      comments: message,
    };
    await postCustomerRequestData(payload);
    toast.success("Request submitted successfully!");
    setMessage("");
    onHide();
    if (onSubmit) onSubmit(payload);
  };

  return (
    <ReusableModal
      show={show}
      onHide={onHide}
      title="Historical Data Request"
      size="md"
      buttons={[
        { text: "Cancel", variant: "outlined", onClick: onHide },
        { text: "Submit", variant: "active", onClick: handleSubmit },
      ]}
    >
      <div>
        <div className="mb-3">
          <span>
            You are requesting for the Historical data for this location.
          </span>
        </div>
        <textarea
          className="form-control"
          rows={5}
          placeholder="Message here..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </div>
       <ToastContainer position="top-right" autoClose={3000} />
    </ReusableModal>
  );
};

export default HistoricalData;